export type AppearanceType<T> = T | T[];

export default function appearance<T>(entry: AppearanceType<T>) {
  return Array.isArray(entry) ? (value: T) => entry.indexOf(value) !== -1 : (value: T) => entry === value;
}
